import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { LMSCourseService } from '../../../services/lms-courses/lms-course.service';
import {
  ItemLmsCourseAPIResponse,
  LmsCourseAPIResponse,
} from '../../../types/responses/lms-course.responses';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-lms-course-registrations-modal',
  standalone: false,
  templateUrl: './lms-course-registrations-modal.component.html',
  styleUrl: './lms-course-registrations-modal.component.scss',
})
export class LmsCourseRegistrationsModalComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  @ViewChild('modal') modal: ModalComponent;

  @Input() courseId: number;

  @Output() readonly modalReset = new EventEmitter();

  course: LmsCourseAPIResponse | null;

  subs: Subscription[] = [];

  isLoading: boolean;

  totalRegistrations = 0;

  currentPage = 1;

  constructor(private CourseService: LMSCourseService) {}

  ngOnInit() {
    if (this.courseId) {
      this.loadRegistrations();
    }
  }

  ngAfterViewInit(): void {
    this.modal.open();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['courseId']) {
      this.loadRegistrations();
    }
  }

  loadRegistrations() {
    this.isLoading = true;
    if (this.courseId) {
      this.subs.push(
        this.CourseService.getCourse(
          this.courseId,
          'registrations.user.profile'
        ).subscribe((resp: ItemLmsCourseAPIResponse) => {
          this.course = resp.item;
          this.isLoading = false;
        })
      );
    }
  }

  resetModal() {
    this.course = null;
    this.modalReset.emit();
  }

  ngOnDestroy(): void {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }

    if (this.modal) {
      this.modal.close();
    }
    this.modalReset.emit();
  }
}
